import { useState, useEffect } from "react";
import { getHours, getMinutes } from "date-fns";

function useCurrentMinute(): number {
  const [minute, setMinute] = useState<number>(0);

  useEffect(() => {
    const handle = setInterval(() => {
      const now = new Date();
      const m = getHours(now) * 60 + getMinutes(now);
      if (minute !== m) {
        setMinute(m);
      }
    }, 30);

    return () => clearInterval(handle);
  }, [minute]);

  return minute;
}

export default useCurrentMinute;
